<c-card ngPreserveWhitespaces class="bg-light">
  <c-card-header>Pipeline Dashboard</c-card-header>
  <c-card-body class="bg-gradient" style="max-height: max-content;">
      <c-card class="mb-2">
        <c-card-header>Date Range</c-card-header>
        <c-card-body>
          <c-row [gutter]="0" class="justify-content-between align-items-center">
            <c-col md="5">
              <c-date-range-picker
                [(endDate)]="endDate"
                [(startDate)]="startDate"
                [calendarDate]="calendarDate"
                [firstDayOfWeek]="1"
                [locale]="locale"
                closeOnSelect
                [inputReadOnly]="true"
                (endDateChange) = "loadPage()"
                [disabled]="btnFilterValue.value.filterRadioValue !== 'None'"
                >
              </c-date-range-picker>
            </c-col>
            <c-col md="2" style="display: none;">
              <!-- <button (click)="getPipelineDashData(true)" [loading]="loading[0]" cLoadingButton disabledOnLoading [disabled]="lookupLoading">{{ loading[0] ? 'Loading' : 'Search/Update' }}</button> -->
              <c-form-check [switch]="true">
                <input cFormCheckInput type="checkbox" [value]="selectAllStages" (click)="toggelSelectAll()"/>
                <label cFormCheckLabel>Select all stages</label>
              </c-form-check>
            </c-col>
            <c-col md="5">
              <c-button-group [formGroup] = 'btnFilterValue'>
                <input class="btn-check" formControlName="filterRadioValue" id="None" type="radio" value = "None" />
                <label (click)="setFilterBtnValue('None')" cButton cFormCheckLabel for="None"  variant="outline" size="sm" >None</label>

                <input class="btn-check" formControlName="filterRadioValue" id="CurrentYTD" type="radio" value = "CurrentYTD"/>
                <label (click)="setFilterBtnValue('CurrentYTD')" cButton cFormCheckLabel for="CurrentYTD" variant="outline" size="sm" >YTD</label>

                <input class="btn-check" formControlName="filterRadioValue" id="CurrentMonth" type="radio" value="CurrentMonth" />
                <label (click)="setFilterBtnValue('CurrentMonth')" cButton cFormCheckLabel for="CurrentMonth" variant="outline" size="sm" >Current Month</label>

                <input class="btn-check" formControlName="filterRadioValue" id="LastMonth" type="radio" value = "LastMonth"/>
                <label (click)="setFilterBtnValue('LastMonth')" cButton cFormCheckLabel for="LastMonth" variant="outline" size="sm" >Last Month</label>

                <input class="btn-check" formControlName="filterRadioValue" id="CurrentWeek" type="radio" value = "CurrentWeek"/>
                <label (click)="setFilterBtnValue('CurrentWeek')" cButton cFormCheckLabel for="CurrentWeek" variant="outline" size="sm" >Current Week</label>

                <input class="btn-check" formControlName="filterRadioValue" id="LastWeek" type="radio" value = "LastWeek"/>
                <label (click)="setFilterBtnValue('LastWeek')" cButton cFormCheckLabel for="LastWeek" variant="outline" size="sm" >Last Week</label>
              </c-button-group>
            </c-col>
          </c-row>
        </c-card-body>
      </c-card>
    <c-row [gutter]="2" style="height: 745px;">
      <c-col md = "3"  class="overflow-auto" style="height: 735px;">
        <c-row [sm]="1" [gutter]="2">
          <c-col >
            <c-card >
              <c-card-header>Week Number</c-card-header>
              <c-card-body *ngIf="lookupListLoading[0]; else cardWeekNumberList"><c-spinner color="primary" size="sm"></c-spinner> Loading</c-card-body>
              <ng-template #cardWeekNumberList>
                <c-card-body>
                  <span *ngIf="getFormWeekNumbers.length === 0">No data</span>
                  <c-row [formGroup]="dataFilters" xs="auto" [gutter]="1">
                    <c-col formArrayName="weekNumbers" *ngFor="let num of getFormWeekNumbers.controls; let i = index" >
                      <input class="btn-check" formControlName="{{i}}" type="checkbox" />
                      <label (click)="setValues(i, 'weekNumbers', $event)" cButton cFormCheckLabel variant="outline" >{{weekNumbers[i]}}</label>
                    </c-col>
                  </c-row>
                </c-card-body>
              </ng-template>
            </c-card>
          </c-col>
          <c-col >
            <c-card >
              <c-card-header>Country</c-card-header>
              <c-card-body *ngIf="lookupListLoading[1]; else cardCountryList"><c-spinner color="primary" size="sm"></c-spinner> Loading</c-card-body>
              <ng-template #cardCountryList>
                <c-card-body>
                <span *ngIf="getFormCountriesList.length === 0">No data</span>
                <c-row [formGroup]="dataFilters" xs="auto" [gutter]="1">
                  <c-col formArrayName="countryList" *ngFor="let num of getFormCountriesList.controls; let i = index">
                    <input class="btn-check" formControlName="{{i}}" type="checkbox" />
                    <label cButton (click)="setValues(i, 'countryList', $event)" cFormCheckLabel variant="outline">{{countryList[i]}}</label>
                  </c-col>
                </c-row>
              </c-card-body>
              </ng-template>
            </c-card>
          </c-col>
          <c-col >
            <c-card >
              <c-card-header>Office</c-card-header>
              <c-card-body *ngIf="lookupListLoading[2]; else cardOfficeList"><c-spinner color="primary" size="sm"></c-spinner> Loading</c-card-body>
              <ng-template #cardOfficeList>
                <c-card-body>
                  <span *ngIf="getFormOfficeList.length === 0">No data</span>
                  <c-row [formGroup]="dataFilters" xs="auto" [gutter]="1">
                    <c-col formArrayName="officeList" *ngFor="let num of getFormOfficeList.controls; let i = index">
                      <input class="btn-check" formControlName="{{i}}" type="checkbox" />
                      <label cButton (click)="setValues(i, 'officeList', $event)" cFormCheckLabel variant="outline">{{officeList[i]}}</label>
                    </c-col>
                  </c-row>
                </c-card-body>
                </ng-template>
            </c-card>
          </c-col>
          <c-col >
            <c-card >
              <c-card-header>Sales Rep</c-card-header>
              <c-card-body *ngIf="lookupListLoading[3]; else cardConsultantList"><c-spinner color="primary" size="sm"></c-spinner> Loading</c-card-body>
              <ng-template #cardConsultantList>
                <c-card-body>
                  <span *ngIf="getFormConsultantList.length === 0">No data</span>
                  <c-row [formGroup]="dataFilters" xs="auto" [gutter]="1">
                    <c-col formArrayName="consultantList" *ngFor="let consultant of getFormConsultantList.controls; let i = index">
                      <input class="btn-check" formControlName="{{i}}" type="checkbox" />
                      <label cButton (click)="setValues(i, 'consultantList', $event)" cFormCheckLabel variant="outline">{{consultantList[i].consultantName}}</label>
                    </c-col>
                  </c-row>
                </c-card-body>
              </ng-template>
            </c-card>
          </c-col>
        </c-row>
      </c-col>
      <c-col md="9" style="height: 745px;">
        <c-row [md]="2" [gutter]="2">
          <c-col md="12">
            <c-card >
              <c-card-body style="height: 370px;">
                <c-row [gutter]="0" [md]="2">
                  <c-col md="10" ><h5>Pipeline</h5></c-col>
                  <c-col md="2" class="fw-bolder " #gpBlock>{{pipelineRadioGroup.controls['pipelineRadio'].value === 'Expected GP'? "Expected GP (USD)": "Count"}}</c-col>
                  <!-- <c-col md="1" class="fw-bolder ">Ratio</c-col> -->

                  <!-- text-end -->
                  <c-col md="10">
                    <form [formGroup]="pipelineRadioGroup">
                      <c-button-group class="float-end me-3" role="group" sm>
                        <input
                          class="btn-check"
                          formControlName="pipelineRadio"
                          type="radio"
                          value="Count"
                        />
                        <label
                          (click)="togglePipelineDisplayedData('Count')"
                          cButton
                          cFormCheckLabel
                          color="primary"
                          variant="outline"
                          size="sm"
                        >Count</label>

                        <input
                          class="btn-check"
                          formControlName="pipelineRadio"
                          type="radio"
                          value="Expected GP"
                        />
                        <label
                          (click)="togglePipelineDisplayedData('Expected GP')"
                          cButton
                          cFormCheckLabel
                          color="primary"
                          variant="outline"
                          size="sm"
                        >Expected GP</label>
                      </c-button-group>
                    </form>
                    <c-chart #barChart type="bar"
                      [data]="PipelineBarData"
                      [height]="270"
                      [options]="{indexAxis: 'y', plugins: {legend: {display: false}}, maintainAspectRatio: false}"
                      (chartRef)="handleChartRefBar($event)"
                      (getElementAtEvent)="ShowRawStageDataPopup($event)"
                      ></c-chart>
                  </c-col>
                  <c-col md="2" *ngIf="Pipelinestats" [ngSwitch]= "pipelineRadioGroup.controls['pipelineRadio'].value">
                    <c-row [sm]="1" style="height: 275px; padding-top: 50px;" *ngSwitchCase="'Expected GP'" [gutter]="0">
                      <c-col class="fw-semibold " >{{Pipelinestats.Prospect.toLocaleString()}}</c-col>
                        <!-- <c-col class="fw-semibold " sm="6">{{Pipelinestats.GPTotal.toLocaleString()}}</c-col> -->
                        <c-col class="fw-semibold ">{{Pipelinestats.Contacted.toLocaleString()}}</c-col>
                        <!-- <c-col class="fw-semibold ">{{Pipelinestats.GPContactedVsProspectRatio}}</c-col> -->
                        <c-col class="fw-semibold ">{{Pipelinestats.Visited.toLocaleString()}}</c-col>
                        <!-- <c-col class="fw-semibold ">{{Pipelinestats.GPVisitedVsConstctedRatio}}</c-col> -->
                        <c-col class="fw-semibold ">{{Pipelinestats.Proposal.toLocaleString()}}</c-col>
                        <!-- <c-col class="fw-semibold ">{{Pipelinestats.GPProposalVsVisitedRatio}}</c-col> -->
                        <c-col class="fw-semibold ">{{Pipelinestats.Won.toLocaleString()}}</c-col>
                        <!-- <c-col class="fw-semibold ">{{Pipelinestats.GPWonVsProposalRatio}}</c-col> -->
                        <c-col class="fw-semibold ">{{Pipelinestats.Lost.toLocaleString()}}</c-col>
                        <!-- <c-col class="fw-semibold ">{{Pipelinestats.GPLostVsProposalRatio}}</c-col> -->
                    </c-row>
                    <c-row [sm]="1" style="height: 275px; padding-top: 50px;"  *ngSwitchCase="'Count'" [gutter]="0">
                      <c-col class="fw-semibold " >{{Pipelinestats.countProspect.toLocaleString()}}</c-col>
                      <c-col class="fw-semibold ">{{Pipelinestats.countContacted.toLocaleString()}}</c-col>
                      <!-- <c-col class="fw-semibold ">{{Pipelinestats.countContactedVsProspectRatio}}</c-col> -->
                      <c-col class="fw-semibold ">{{Pipelinestats.countVisited.toLocaleString()}}</c-col>
                      <!-- <c-col class="fw-semibold ">{{Pipelinestats.countVisitedVsConstctedRatio}}</c-col> -->
                      <c-col class="fw-semibold ">{{Pipelinestats.countProposal.toLocaleString()}}</c-col>
                      <!-- <c-col class="fw-semibold ">{{Pipelinestats.countProposalVsVisitedRatio}}</c-col> -->
                      <c-col class="fw-semibold ">{{Pipelinestats.countWon.toLocaleString()}}</c-col>
                      <!-- <c-col class="fw-semibold ">{{Pipelinestats.countWonVsProposalRatio}}</c-col> -->
                      <c-col class="fw-semibold ">{{Pipelinestats.countLost.toLocaleString()}}</c-col>
                      <!-- <c-col class="fw-semibold ">{{Pipelinestats.countLostVsProposalRatio}}</c-col> -->
                    </c-row>
                    <c-row [sm]="2" class="fw-semibold" [gutter]="0">
                      <c-col style="text-decoration: underline">Total: </c-col>
                      <c-col *ngSwitchCase="'Expected GP'" >{{Pipelinestats.GPTotal.toLocaleString()}}</c-col>
                      <c-col *ngSwitchCase="'Count'">{{Pipelinestats.countTotal.toLocaleString()}}</c-col>
                    </c-row>
                  </c-col>
                </c-row>
              </c-card-body>
            </c-card>
          </c-col>
          <c-col >
            <c-card >
              <c-card-body style="height: 349px">
                <h5>Pipeline Portfolio</h5>
                <c-chart type="pie"
                [data]="PipelinePortifolioData"

                (chartRef)="handleChartRefPie($event)"
                (getElementAtEvent)="ShowRawProductDataPopup($event)"
                (contextmenu) = "ShowRawProductDataPopup($event)"
                [height]="295"
                [options] = "{
                    plugins: {
                      legend: {
                        position: 'right'
                      }
                    },
                    maintainAspectRatio: false
                  }"
                >
              </c-chart>
              </c-card-body>
            </c-card>
          </c-col>
          <c-col>
            <c-card >
              <c-card-body>
                <h5>No. Of Opportunities Created / Week</h5>
                <c-chart
                  [data]="pipelineActivityData"
                  type="bar"
                  [height]="285"
                  (chartRef)="handleChartRefActivity($event)"
                  [options] = "{
                    scales: {
                      y: {
                        beginAtZero: true,
                        ticks: {
                          stepSize: 2,
                        }
                      }
                    }, interaction: {intersect: false, mode: 'index'}, maintainAspectRatio: false}"
                  >
                </c-chart>
              </c-card-body>
            </c-card>
          </c-col>
        </c-row>
      </c-col>
    </c-row>
  </c-card-body>
</c-card>

<c-modal #verticallyCenteredModal alignment="center" backdrop="static" id="verticallyCenteredModal" [visible]="chartsLoading" size="sm">
  <c-modal-body class="text-center">
    <c-spinner color="primary" size="sm"></c-spinner> Loading
  </c-modal-body>
</c-modal>

<c-modal #rawDataModal alignment="center" id="rawDataModal" [visible]="ShowRawDataPopupVisible" size="xl">
  <c-modal-header>
    <h5 cModalTitle>Raw Data {{productType}}</h5>
    <button (click)="toggleRawDataPopupVisible()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body class="text-center">
    <app-smart-table [tableData] = "tableRawData" [columns]="tableRawDataColumns"></app-smart-table>
  </c-modal-body>
</c-modal>